import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'management',
  initialState: {},
  reducers: {},
});

export default slice;
